<template>
  <div class="preview">
      <div class="et-tabhead">
          <span class="et-back" @click="detail">
            <i class="icon-back"></i>
            返回
          </span>
        <div class="et-tabtn">
          <div class="et-tabtn" id="but-tabtn">
              <span class="btn-et-form et-form-on" @click="form(1)">
                    <i class="icon-form"></i>投票
                  </span>
              <span class="btn-et-form" @click="form(2)">
                <i class="icon-vote"></i>排名
              </span>
          </div>
        </div>
      </div>
      <div class="preview-conten preview-contenNext" style="margin-top: 16px" v-if="itemName">
        <div class="preview-user">
          <img :src="globalUrl + 'static/dist/img/Head-portrait.jpg'" alt=""/>
          <span>{{itemName.nickname}}</span>
        </div>
        <!--播放器开始-->
        <div  id="myFlash" v-if="typeName != 2" class="video_left"></div>
        <div id="myImg" v-else style="width: 100%">
          <img id="asImg" style="width:100%;height: auto;min-height: 50px;" :src="asImg" alt=""/>
        </div>
        <div class="preview-text">
          <h4>{{itemName.title}}</h4>
          <p class="preview-p">
            <span class="preview-span">{{itemName.description}}</span>
          </p>
        </div>

          <p class="show-v-more" @click="showVmore"> <i class="icon-vs-show"></i></p>

      </div>
      <div class="show-box"  >
        <!--投票-->
        <div class="show-list" v-if="itemName">
          <!--<div  :class="itemName.end_time + 86400000>(new Date()).getTime() && (new Date()).getTime()>itemName.start_time?'show-btn-poll':'show-btn-poll show-btn-poll-over'" :data-id="itemName.uuid" style="padding: 10px;font-size: 20px">
            <i class="icon-poll"><em>+1</em></i>投票
          </div>-->
          <div class="show-btn-poll" :activity_id="activity_id" :data-id="uuid" style="padding: 10px;font-size: 20px">
            <i class="icon-poll"><em>+1</em></i>投票
          </div>
          <p class="show-poll">
            <span>{{vote_count}}</span>票  <!--第<span>{{itemName.rank}}</span>名-->
          </p>
        </div>
      </div>
    <div class="yaVideo" style="display: none;text-align: center;padding: 50px 0">呀！作品找不到了！</div>
    <VoteAlert></VoteAlert>
    </div>
</template>

<script>
  import voteAlert from '../template/voteAlert.vue';
    export default {
        data ()
    {
        return {
          itemName: null,
          detailsTxte: '',
          showVmoreName: false,
          asImg: "",
          globalUrl : API.GlobalUrl,
          typeName: 2,
          data: '',
          vote_count: '0',
          activity_id:　'',
          uuid : ''
        }
    }
    ,
    components:{
      VoteAlert: voteAlert
    },
    methods: {
        //操作按钮事件
      //详情更多
      showVmore(){
        this.showVmoreName = !this.showVmoreName
        if(this.showVmoreName){
          $('.preview-p').css({'max-height': 'none'})
          $('.show-v-more').css({'transform': 'rotate(180deg)'})
        }else{
          $('.preview-p').css({'max-height': '60px'})
          $('.show-v-more').css({'transform': 'rotate(0deg)'})
        }
      },
      detail(){
        var img = $('.dl-banner').children('img').attr('src');
        // this.$router.push({name: 'list_vote', params: {id:  this.id,active: 1}})
        this.$router.go(-1)

      },
      form(val){
        var img = $('.dl-banner').children('img').attr('src');
        this.$router.push({name: 'list_vote', params: {id:  this.id,active: val}})
      }
    },
    created: function () {
      this.id = this.$route.params.id;
      this.typeName = this.$route.params.ind;
      this.activity_id = this.$route.params.activityId;
      var type = this.$route.params.ind;
      var uuid = this.$route.params.uuid;
      this.uuid = this.$route.params.uuid;
      var that = this;

      var getVideoInfo = '',
        APIName = '';
      if(type == 2){ //图片
        APIName = API.GetImageInfo;
      }else{  //视频
        APIName = API.GetVideoInfo;
      }
      getVideoInfo = {
        file_id: uuid,
        version: 2
      };
    console.log(this.activity_id,uuid)
      that.$http.get(API.VoteActivity, {params: {activity_id: this.activity_id,file_id: uuid}})
        .then(function (res) {
         console.log(res)
          if(res.code == 0){
            that.data = res.data;
            that.vote_count = that.data.vote_count;
            var cyrrend = new Date().getTime(),
              end_time = new Date(that.data.end_time).getTime(),
              start_time = new Date(that.data.start_time).getTime();
            //判断是否在投票时间内
            if (!cyrrend < end_time && !cyrrend > start_time) {
              $('.show-btn-poll').addClass('show-btn-poll-over');
            }
          }
        });
      that.$http.get(APIName, {params: getVideoInfo})
        .then(function (res) {
         // console.log(res)
          if(res.code == 0){
            that.itemName =  res.data;
            if(type == 2){
              that.asImg =  that.itemName.image_url
            }else{
              var w = $('.et-tabhead').width() -32,
                h =  Math.ceil(w/1.78);
               that.VideoPlay(uuid,w,h);
            }
            that.$nextTick(function () {
              if($('.preview-span').height() > 60){
                $('.show-v-more').show()
              }else{
                $('.show-v-more').hide()
              }
            })

          }else{
            $('.yaVideo').show()
          }
        });
       $.getJSON(API.GetActivitieById + '?jsoncallback=?&id=' + that.id, function (res) {
          that.detailsTxte = res.data;
          if (res.code == 0) {
            //分享微信
            var title = '',
              desc = '';
            if(that.detailsTxte.share_config){
              var activity = that.detailsTxte.share_config.activity;
              if(activity != 'undefined' && activity &&activity.share_title){
                title = activity.share_title
              }else{
                title = that.detailsTxte.title;
              }
              if(activity != 'undefined' && activity && activity.share_contents){
                desc = activity.share_contents
              }else{
                desc  = that.detailsTxte.description
              }
            }else{
              title = that.detailsTxte.title;
              desc  = that.detailsTxte.description
            }
            document.title = title;
            let metas = $('head').children('meta');
            metas[1].content = desc;
            var dataName = {
              title: '我参加' + title + '活动，快帮我投票',
              desc: desc,
              imgAddress: that.route,
              Retain: '',// 保留
              url: window.location.href
            };
            that.weixinShare(dataName)
          }
        });
    },
    mounted: function () {
      //操作DOM
    }

    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/list/preview.vue